var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchTransfer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:none;stroke:#B3B3B3;stroke-width:0.1;stroke-miterlimit:10;}\n\t.st3{fill:#006747;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: -0.5,
    className: "st2",
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30.4,
    y1: -0.5,
    x2: 30.4,
    y2: 59.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 60.4,
    y1: 29.5,
    x2: 0.4,
    y2: 29.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0.4,
    y1: -0.5,
    x2: 60.4,
    y2: 59.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4,
    y: 7.5,
    className: "st2",
    width: 44,
    height: 44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 60.4,
    y1: -0.5,
    x2: 0.4,
    y2: 59.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0.4,
    y1: 29.5,
    x2: 30.4,
    y2: -0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30.4,
    y1: -0.5,
    x2: 60.4,
    y2: 29.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 60.4,
    y1: 29.5,
    x2: 30.4,
    y2: 59.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30.4,
    y1: 59.5,
    x2: 0.4,
    y2: 29.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 30.4,
    cy: 29.5,
    r: 21
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.3,25.1c0.6,0,1-0.4,1-1v-2c0-0.6-0.4-1-1-1H9.5c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h1v14.7h-1 c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h5.9c0.6,0,1-0.4,1-1v-2c0-0.6-0.4-1-1-1h-1V25.1H15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.5,25.1c0.6,0,1-0.4,1-1v-2c0-0.6-0.4-1-1-1h-5.9c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h1v14.7h-1 c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h5.9c0.6,0,1-0.4,1-1v-2c0-0.6-0.4-1-1-1h-1V25.1H50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30,0.7L2.6,15.3v3.9h54.7v-3.9L30,0.7z M30,13.4c-2.2,0-3.9-1.8-3.9-3.9s1.8-3.9,3.9-3.9s3.9,1.8,3.9,3.9 S32.2,13.4,30,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30,33.9c-7,0-12.7,5.7-12.7,12.7S23,59.3,30,59.3s12.7-5.7,12.7-12.7S37,33.9,30,33.9z M30,57.4 c-6,0-10.8-4.8-10.8-10.8S24,35.9,30,35.9s10.8,4.8,10.8,10.8S36,57.4,30,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.2,51.5H2.6v3.9h15.6C17.4,54.2,16.7,52.9,16.2,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.8,51.5c-0.5,1.4-1.2,2.7-2.1,3.9h15.6v-3.9H43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.3,46.6c0-0.3,0-0.7,0.1-1H5.6v3.9h10.1C15.4,48.6,15.3,47.6,15.3,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.6,45.6c0,0.3,0.1,0.7,0.1,1c0,1-0.1,2-0.3,2.9h10.1v-3.9H44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.8,21.2h-5.9c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h1v7.4c1.4,0.4,2.7,1,3.9,1.7v-9.1h1c0.6,0,1-0.4,1-1v-2 C39.8,21.6,39.4,21.2,38.8,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.1,21.2h-5.9c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h1v9.1c1.2-0.7,2.5-1.3,3.9-1.7v-7.4h1c0.6,0,1-0.4,1-1v-2 C28,21.6,27.7,21.2,27.1,21.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "38.7,42.7 32,38.8 32,41.7 21.2,41.7 21.2,43.7 32,43.7 32,46.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "38.8,49.6 28,49.6 28,46.6 21.3,50.5 28,54.4 28,51.5 38.8,51.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchTransfer);
export default __webpack_public_path__ + "static/media/ACHTransfer.68c8658d6b9e2143a8e3bb0375ad8466.svg";
export { ForwardRef as ReactComponent };